var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"footer-grid__list"},[_c('li',[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_vm._l((_vm.links),function(link,index){return _c('li',{key:index},[_c('nuxt-link',{key:link.index,attrs:{"to":_vm.$prismic.linkResolver(link.link)}},[_vm._v("\n            "+_vm._s(link.text)+"\n        ")])],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }